import startsWith from 'lodash-es/startsWith';

/**
 * In some cases, a single service object can appear with different properties in different
 * contexts. An example is the conversation list where a conversation may appear with different properties
 * in different folders but has a single conversation id in the service.
 *
 * Since we need to have a different id in each context for apollo caching, the compositeId concatenate
 * the server ID with a context string (chosen as appropriate per scenario)
 */

const compositeIdPrefix = 'composite-';

export function isCompositeId(id: string | undefined | null) {
    return id && startsWith(id, compositeIdPrefix);
}

export function createCompositeId(itemId: string, context: string) {
    return `${compositeIdPrefix}${itemId}_${context}`;
}

export function getItemIdFromCompositeId(compositeId: string) {
    return compositeId.slice(compositeIdPrefix.length).split('_')[0];
}

export function tryGetItemIdFromCompositeId(compositeId: string) {
    return isCompositeId(compositeId) ? getItemIdFromCompositeId(compositeId) : null;
}
